const photos = [
  {
    src: "https://tradeposter.blob.core.windows.net/tradeposter/images/TradesPoster-banner-3---SMALL-QUALITY-1747311981823.jpg",
    width: 1080,
    height: 720,
  },
  {
    src: "https://tradeposter.blob.core.windows.net/tradeposter/images/TradesPoster-banner-2---FULL-QUALITY-1747311998804.jpg",
    width: 1080,
    height: 1112,
  },
  {
    src: "https://tradeposter.blob.core.windows.net/tradeposter/images/marian-florinel-condruz-C-oYJoIfgCs-unsplash-1750089566203.jpg",
    width: 1080,
    height: 1472,
  },
  {
    src: "https://tradeposter.blob.core.windows.net/tradeposter/images/erik-mclean-IxfhMTROke8-unsplash-1747419362866.jpg",
    width: 1080,
    height: 1112,
  },
  {
    src: "https://tradeposter.blob.core.windows.net/tradeposter/images/General-Plumbing-1745498265607-1750972529476.webp",
    width: 1080,
    height: 1472,
  },
  {
    src: "https://tradeposter.blob.core.windows.net/tradeposter/images/So-You-Want-to-Be-a--Plumber-R-1750089988084.jpg",
    width: 1080,
    height: 720,
  },
  {
    src: "https://tradeposter.blob.core.windows.net/tradeposter/images/chandler-cruttenden-dDluNWaVQWA-unsplash-1751902595119.jpg",
    width: 1080,
    height: 720,
  },
  {
    src: "https://tradeposter.blob.core.windows.net/tradeposter/images/gabriel-alenius-cPDTVCsbxcg-unsplash-1751902617041.jpg",
    width: 1080,
    height: 1112,
  },
  {
    src: "https://tradeposter.blob.core.windows.net/tradeposter/images/charlesdeluvio-c2thq3SXJiA-unsplash-1751902649653.jpg",
    width: 1080,
    height: 1472,
  },
  {
    src: "https://tradeposter.blob.core.windows.net/tradeposter/images/jimmy-nilsson-masth-vLKc9oqD2MA-unsplash-1751902650169.jpg",
    width: 1080,
    height: 720,
  },
  {
    src: "https://tradeposter.blob.core.windows.net/tradeposter/images/charlesdeluvio-6rNTDKruMWU-unsplash-1751902675580.jpg",
    width: 1080,
    height: 1112,
  },
  {
    src: "https://tradeposter.blob.core.windows.net/tradeposter/images/jared-muller-EkhWxU-pgLo-unsplash-1751902676292.jpg",
    width: 1080,
    height: 1472,
  },
  {
    src: "https://tradeposter.blob.core.windows.net/tradeposter/images/superior-plumbing-and-drains-plumber-how-to-patch-a-leaky-pipe-1751902708186.jpg",
    width: 1080,
    height: 720,
  },
  {
    src: "https://tradeposter.blob.core.windows.net/tradeposter/images/glenov-brankovic-t9eQm2y1tn8-unsplash-1751902708539.jpg",
    width: 1080,
    height: 1112,
  },
  {
    src: "https://tradeposter.blob.core.windows.net/tradeposter/images/josh-olalde-EWoU3snzadU-unsplash-1751902743763.jpg",
    width: 1080,
    height: 1472,
  },
  // {
  //   src: "https://tradeposter.blob.core.windows.net/tradeposter/images/rose-galloway-green-MzPnzK3prTU-unsplash--1--1746791857356-1750089568069.webp",
  //   width: 1080,
  //   height: 1112,
  // },
  // {
  //   src: "https://tradeposter.blob.core.windows.net/tradeposter/images/TradesPoster-banner-3---SMALL-QUALITY-1747311981823.jpg",
  //   width: 1080,
  //   height: 1112,
  // },
];

export default photos;
